module.exports = __webpack_public_path__ + "static/img/265_TO8_2350.1c40142.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/265_TO8_2350.jpg
// module id = 2dcA
// module chunks = 0